// src/utils/backendClient.js
import axios from "axios";

const backendClient = axios.create({
  baseURL: "https://prod-api.luckify.co/",
  headers: {
    "Content-Type": "application/json",
  },
});

backendClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

backendClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error.response || error.message);
    return Promise.reject(error);
  }
);

export default backendClient;
